module.exports = __webpack_public_path__ + "static/media/StudioSoftbox.690fc735.env";